import React from 'react'
import './_styles.scss'
import Utils from '../../../../../../../../../utils/Utils'
import Translator from '../../../../../../../../../requests/apa/Translator'

function CountryDetailsRight ({ matches, points }) {
  return (
    <div className='country-details-header__stats'>
      <div className='country-details-header__stat'>
        <p className='country-details-header__stat-label'>{Utils.cutPlayerString(Translator.get('eventodeportivo_paises_fichasuperior_texto_titulo_partidos'), 8)}</p>
        <p className='country-details-header__stat-value'>{Utils.cutPlayerString(matches != null ? matches : '—', 4)}</p>
      </div>
      <div className='country-details-header__stat country-details-header__stat--last'>
        <p className='country-details-header__stat-label'>{Utils.cutPlayerString(Translator.get('eventodeportivo_paises_fichasuperior_texto_titulo_puntos'), 8)}</p>
        <p className='country-details-header__stat-value'>{Utils.cutPlayerString(points != null ? points : '—', 4)}</p>
      </div>
    </div>
  )
}

export default CountryDetailsRight



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/components/CountryDetailsModal/Components/CountryDetailsHeader/Components/CountryDetailsRight/index.jsx